(function () {
  'use strict';

  function init() {
    var items = Array.from(document.querySelectorAll('.header .fp-nav-dropdown'));

    function setOpen(item, open) {
      var button = item.querySelector('.fp-nav-toggle');
      item.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', (open ? 'Close ' : 'Open ') + button.dataset.menuTitle + ' menu');
      if (!open) item.removeAttribute('data-pinned');
    }

    function closeOthers(except) {
      items.forEach(function (item) { if (item !== except) setOpen(item, false); });
    }

    items.forEach(function (item) {
      var button = item.querySelector('.fp-nav-toggle');
      var parentLink = item.querySelector('a.sub-menu');
      var links = item.querySelectorAll('.dropdown a');
      button.addEventListener('click', function () {
        var open = item.getAttribute('data-pinned') !== 'true';
        closeOthers(item);
        setOpen(item, open);
        if (open) item.setAttribute('data-pinned', 'true');
      });
      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch' || !window.matchMedia('(hover: hover)').matches) return;
        closeOthers(item);
        setOpen(item, true);
      });
      item.addEventListener('pointerleave', function () {
        if (!item.contains(document.activeElement)) setOpen(item, false);
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });
      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(item, false);
          button.focus();
        } else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') &&
            (event.target === button || event.target === parentLink)) {
          event.preventDefault();
          closeOthers(item);
          setOpen(item, true);
          if (links.length) links[event.key === 'ArrowDown' ? 0 : links.length - 1].focus();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.fp-nav-dropdown')) closeOthers();
    });

    var nav = document.getElementById('nav');
    if (!nav) return;
    function syncMobile() {
      nav.querySelectorAll('a.mm-subopen').forEach(function (link) {
        var label = link.nextElementSibling;
        var title = label ? label.textContent.trim() : 'submenu';
        var id = (link.getAttribute('href') || '').slice(1);
        var panel = document.getElementById(id);
        link.setAttribute('aria-label', 'Open ' + title + ' menu');
        link.setAttribute('role', 'button');
        link.setAttribute('aria-controls', id);
        link.setAttribute('aria-expanded', String(!!panel && panel.classList.contains('mm-current')));
      });
    }
    new MutationObserver(syncMobile).observe(nav, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
    syncMobile();

    nav.addEventListener('keydown', function (event) {
      if (event.key === ' ' && event.target.matches('a.mm-subopen')) {
        event.preventDefault();
        event.target.click();
      } else if (event.key === 'Escape') {
        var back = nav.querySelector('.mm-panel.mm-current .mm-subclose');
        if (back) { event.preventDefault(); back.click(); }
      } else if (event.key === 'Tab' && nav.classList.contains('mm-opened')) {
        // The legacy menu blocks Tab globally; keep keyboard focus in its active panel.
        var controls = Array.from(nav.querySelectorAll('a[href], button, input')).filter(function (el) {
          var panel = el.closest('.mm-panel');
          return !el.disabled && el.getClientRects().length && (!panel || panel.classList.contains('mm-current'));
        });
        if (!controls.length) return;
        event.preventDefault();
        event.stopPropagation();
        var index = controls.indexOf(document.activeElement);
        var next = (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
        controls[next].focus();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
